import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateShiftRequest extends BaseUpdateRequest {
    startAt: Date;
    endAt: Date;
    quantity: number;
    break: number;
    isPaidBreak: boolean;
}